var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectProduct = function SvgSelectProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 128,
    width: 128,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "select-product_svg__b",
    height: "1300%",
    width: "166.7%",
    x: "-33.3%",
    y: "-600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "select-product_svg__c",
    height: "1300%",
    width: "160%",
    x: "-30%",
    y: "-600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "select-product_svg__d",
    height: "1300%",
    width: "160%",
    x: "-30%",
    y: "-600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "select-product_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7eb8f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "select-product_svg__a",
    d: "M25 11.197v8.606a5.998 5.998 0 0 1 2.998 5.026l12.26 10.264a3 3 0 1 1 .556 5.902L32 50.855V61H12V50.785L3.246 40.99a3 3 0 1 1 .545-5.885L16 24.883a5.998 5.998 0 0 1 3-5.08v-8.606a6 6 0 1 1 6 0zm-7.485 17.789L6 37.968V38a2.99 2.99 0 0 1-.8 2.04l6.8 9.372V41h20v8.5l6.836-9.422a2.99 2.99 0 0 1-.835-2.159l-11.49-8.962A5.986 5.986 0 0 1 22 31a5.985 5.985 0 0 1-4.485-2.014z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "select-product_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#select-product_svg__a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 21h56v1H36z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 91h88l12 21H8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 83h18v1H47z",
    filter: "url(#select-product_svg__b)",
    transform: "translate(8 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 84h20v1H20z",
    filter: "url(#select-product_svg__c)",
    transform: "translate(8 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 84h20v1H72z",
    filter: "url(#select-product_svg__d)",
    transform: "translate(8 16)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 82h20v20H28zm52 0h20v20H80z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 16)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#select-product_svg__e)",
    xlinkHref: "#select-product_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#33a0ff",
    mask: "url(#select-product_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42-17H86v128H-42z"
  }))))));
};
export default SvgSelectProduct;